<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/main/content/eguard.component.html